<script>
    import Button from "../../ui_elements/Button.svelte";
    import { post } from "../../utility.js";
    import PageBox from "../../layouts/PageBox.svelte";
    import { generateRandomPassword } from "./admin-utility";
    import { pop } from 'svelte-spa-router';
    import ContentBox from "../../layouts/ContentBox.svelte";

    let pageTitle = "Registrierung";
    let description = "Neuen Nutzer anlegen.";

    let username = "";
    let authenticationCode = "";
    let guidedMode = false;
    let ausbildungenOnly = false;
    let isStaff = false;
    let information = "";

    let newUser = null;

    function handleKeyDown(event) {
        if (event.key === 'Enter') {
            handleRegister();
        }
    }

    function generatePassword() {
        authenticationCode = generateRandomPassword();
    }

    async function handleRegister() {
        if (!username || !authenticationCode) {
            information = "Username und Authentifizierungscode müssen gesetzt sein.";
            return;
        }
        try {
            const response = await post('register/', { 
                username: username, 
                password: authenticationCode,
                job_type_score: 0,
                guided_mode: guidedMode,
                ausbildungen_only: ausbildungenOnly,
                is_staff: isStaff,
            });

            information = "";
            newUser = { username, authenticationCode, guidedMode, ausbildungenOnly, isStaff };
            
            username = "";
            authenticationCode = "";
            guidedMode = false;
            ausbildungenOnly = false;
            isStaff = false;

        } catch (err) {
            information = err.message;
        }
    }
</script>

<PageBox {pageTitle} {description}>  

     <ContentBox w="1/3" minWidth = "300px">    
        {#if information != ""}
            <div class="mb-4 p-4 bg-accent-light border border-accent-border text-accent-text rounded">
                {information}
            </div>            
        {/if}

        {#if newUser}
            <div class="mb-4 p-4 bg-accent2-background border border-accent2-border text-accent2-text rounded">
                <p>Der folgende Nutzer wurde erfolgreich erstellt:</p>
                <p>Username: {newUser.username}</p>
                <p>Authentifizierungscode: {newUser.authenticationCode}</p>
                <p>Geführter Modus: {newUser.guidedMode ? "Ja" : "Nein"}</p>
                <p>Nur Ausbildungen: {newUser.ausbildungenOnly ? "Ja" : "Nein"}</p>
                <p>Admin: {newUser.isStaff ? "Ja" : "Nein"}</p>
            </div>
        {/if}

        
        <div class="mb-6">
            <label for="username" class="block text-sm font-medium leading-6">Username</label>
            <input id="username" bind:value={username} placeholder="Username für den neuen Nutzer" type="text" required class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-accent-border sm:text-sm sm:leading-6" on:keydown={handleKeyDown}>
        </div>
    
        <div class="mb-6">
            <label for="authenticationCode" class="block text-sm font-medium leading-6">Authentifizierungscode</label>
            <input id="authenticationCode" bind:value={authenticationCode} placeholder="Passwort für den neuen Nutzer" type="text" required class="block w-full rounded-md border-0 py-1.5 text-gray-900 mb-2 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-accent-border sm:text-sm sm:leading-6" on:keydown={handleKeyDown}>

            <Button on:click={generatePassword} className="w-full rounded-md">
                <div class="flex gap-2">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-shuffle cursor-pointer"><path d="M2 18h1.4c1.3 0 2.5-.6 3.3-1.7l6.1-8.6c.7-1.1 2-1.7 3.3-1.7H22"/><path d="m18 2 4 4-4 4"/><path d="M2 6h1.9c1.5 0 2.9.9 3.6 2.2"/><path d="M22 18h-5.9c-1.3 0-2.6-.7-3.3-1.8l-.5-.8"/><path d="m18 14 4 4-4 4"/></svg>
                    <p class="text-gray-700">Zufälligen Authentifizierungscode generieren</p>
                </div>
            </Button>
        </div>
        
        <ul class="text-secondary-text">
            <li class="flex items-center ps-3">
                <input type="checkbox" bind:checked={guidedMode} id="guidedmode" class="rounded text-accent-highlight bg-gray-100 border-gray-300 focus:ring-accent-border">
                <label for="guidedmode" class="py-1 ms-2">Geführter Modus (Ergebnisse sind nicht direkt einsehbar)</label>
            </li>

            <li class="flex items-center ps-3">
                <input type="checkbox" bind:checked={ausbildungenOnly} id="ausbildungenOnly" class="rounded text-accent-highlight bg-gray-100 border-gray-300 focus:ring-accent-border">
                <label for="ausbildungenOnly" class="py-1 ms-2">Nur Ausbildungen</label>
            </li>

            <li class="flex items-center ps-3">
                <input type="checkbox" bind:checked={isStaff} id="isStaff" class="rounded text-accent-highlight bg-gray-100 border-gray-300 focus:ring-accent-border">
                <label for="isStaff" class="py-1 ms-2">Admin</label>
            </li>
        </ul>

        <Button on:click={handleRegister} className="w-full rounded-md" variant="submit">Registrieren</Button>
    </ContentBox>

    <div class="flex mx-4 mb-2 justify-between w-1/3" style="min-width: 300px">
        <Button variant="default" on:click={pop}>
            <div class="flex gap-2">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-move-left"><path d="M6 8L2 12L6 16"/><path d="M2 12H22"/></svg>
                <p>Zurück zum Adminbereich</p>
            </div>
        </Button>   
    </div>

</PageBox>
